import { isObjectEmpty } from '@/utils/comparisonUtils';

export const getBreadcrumbItems = (list) => list?.filter((elem) => elem.name !== '');

export const computeBreadcrumb = (product) => {
	if (!product || isObjectEmpty(product)) {
		return [];
	}

	const breadcrumb = product.breadcrumbSeo ? [].concat(product.breadcrumbSeo) : [];

	if (breadcrumb && !breadcrumb.find((b) => b?.url === product.seoKeyword)) {
		breadcrumb.push({
			name: product.productName,
			url: product.seoKeyword,
		});
	}

	return breadcrumb;
};
